import React, { forwardRef, Ref, SVGProps } from 'react'

const _IconExpediaRectangle = (props: SVGProps<SVGSVGElement>, ref?: Ref<SVGSVGElement>) => (
  <svg width="25" height="24" viewBox="0 0 25 24" fill="none" {...props} ref={ref}>
    <g clipPath="url(#clip0_5098_130914)">
      <rect x="0.399902" width="24" height="24" rx="6" fill="#0C3B7C" />
      <path
        d="M5.28354 -0.117188H19.4C22.17 -0.117188 24.4001 2.11285 24.4001 4.88291V18.9992C24.4001 21.7693 22.17 23.9993 19.4 23.9993H5.28354C2.51349 23.9993 0.283447 21.7693 0.283447 18.9992V4.88291C0.283447 2.11285 2.51349 -0.117188 5.28354 -0.117188Z"
        fill="#FDDB32"
      />
      <path
        d="M8.69716 6C8.52303 6.00001 8.41358 6.04002 8.32137 6.13223L6.45407 7.99954C6.41939 8.03421 6.39991 8.08127 6.3999 8.1303C6.39989 8.23239 6.48267 8.31515 6.58476 8.31516H14.6796L9.7031 13.2916C9.60503 13.3897 9.54798 13.4467 9.54798 13.6392L9.54798 14.9485C9.54798 15.0278 9.58405 15.0965 9.6358 15.1483C9.68755 15.2 9.7562 15.236 9.83549 15.236H11.1449C11.3374 15.236 11.3944 15.1791 11.4924 15.081L16.4689 10.1045V18.1993C16.4689 18.3014 16.5517 18.3842 16.6538 18.3842C16.7028 18.3842 16.7499 18.3647 16.7846 18.33L18.6519 16.4627C18.7441 16.3705 18.7841 16.2611 18.7841 16.0869L18.7841 7.24782C18.7841 7.08395 18.7518 6.92168 18.6891 6.77029C18.6264 6.61889 18.5344 6.48133 18.4186 6.36546C18.3027 6.24959 18.1651 6.15768 18.0137 6.09497C17.8623 6.03227 17.7001 6 17.5362 6L8.69716 6Z"
        fill="#191E3B"
      />
      <path
        d="M7.11129 15.5996H8.90745C9.0577 15.5996 9.17865 15.7206 9.17865 15.8708V17.6782C9.17865 17.8285 9.0577 17.9494 8.90745 17.9494H7.11129C6.96104 17.9494 6.84009 17.8285 6.84009 17.6782V15.8708C6.84009 15.7206 6.96104 15.5996 7.11129 15.5996Z"
        fill="#191E3B"
      />
    </g>
    <defs>
      <clipPath id="clip0_5098_130914">
        <rect x="0.399902" width="24" height="24" rx="6" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

export const IconExpediaRectangle = forwardRef(_IconExpediaRectangle)
